import assign from "lodash.assign";
import { LOCATION_CHANGE } from "react-router-redux";
import { browserHistory } from "react-router";

import loginActions from "ducks/loginRegister";
import { setThinking, doneThinking } from "ducks/thinking";
import GoogleTracking from "services/GoogleTracking";
import User from "../services/User";
import Entitlements from "../services/Entitlements";
import Redirect from "../utils/Redirect";
import appPath from "utils/appPath";
import { isOnboardingEnabled } from "utils/FeatureFlags";
import { SCREENS } from "common/constants/Constants";

// Actions (must be name-spaced for reducer)

export const USER_UPDATE_USER_STORE = "USER_UPDATE_USER_STORE";
export const USER_UPDATE_MARKETING_OPTION = "USER_UPDATE_MARKETING_OPTION";
export const USER_UPDATE_REFERRAL_SHARING_PREFERENCE = "USER_UPDATE_REFERRAL_SHARING_PREFERENCE";

// Reducer

export function userReducer(state = {}, action = {}) {
    switch (action.type) {
        case LOCATION_CHANGE:
            return {};
        case USER_UPDATE_USER_STORE:
            action.user.socialAccounts = action.user.socialAccounts || [];

            return assign({}, state, action.user);
        case USER_UPDATE_MARKETING_OPTION:
            return assign({}, state, {
                [action.marketingOptionId]: action.status
            });
        case USER_UPDATE_REFERRAL_SHARING_PREFERENCE:
            return assign({}, state, {
                referralSharingPreference: action.status
            });
        default:
            return state;
    }
}

// Action Creators

export function updateUserStore(user) {
    return {
        type: USER_UPDATE_USER_STORE,
        user
    };
}

export function updateMarketingOption(marketingOptionId, status) {
    return {
        type: USER_UPDATE_MARKETING_OPTION,
        marketingOptionId,
        status
    };
}

export function updateReferralSharingPreference(status) {
    return {
        type: USER_UPDATE_REFERRAL_SHARING_PREFERENCE,
        status
    };
}

export function startFetchingUser() {
    return (dispatch) => {
        return User.fetchUser()
            .then((user) => {
                Redirect.hasRedirectCookie() ? Redirect.handleRedirect() : dispatch(updateUserStore(user));

                return user;
            });
    };
}

export function resetPasswordAndRedirect(isNewUser, email, validationKey, newPassword, location) {
    return (dispatch, getState) => {
        const {
            abba: {
                config: {
                    onboarding: {
                        onboardingEnabled
                    } = {}
                }
            } = {}
        } = getState();

        dispatch(loginActions.clearError("setPassword"));
        dispatch(setThinking());

        return dispatch(loginActions.passwordSubmit(email, newPassword, validationKey, isNewUser))
            .then(() => {
                if (isNewUser) {
                    GoogleTracking.registerCompletionEvent("join_now", "join_now");
                }

                return User.fetchUser()
                    .then((user) => {
                        if (isOnboardingEnabled() && onboardingEnabled) {
                            Entitlements.getSubscriptions({ bulkSubscriptionActive: false })
                                .then((subscriptions) => {
                                    // must be subscribed to see onboarding
                                    if (subscriptions && subscriptions.length > 0) {
                                        browserHistory.push(appPath.withIframePrefix(SCREENS.ONBOARDING));

                                        return;
                                    }

                                    dispatch(loginActions.redirectAfterSignIn(user, location));
                                });

                            return;
                        }

                        dispatch(loginActions.redirectAfterSignIn(user, location));
                    })
                    .catch(() => dispatch(doneThinking()));
            })
            .then(() => dispatch(doneThinking()))
            .catch(() => dispatch(doneThinking()));
    };
}

export default {
    userReducer,
    startFetchingUser,
    updateUserStore,
    updateMarketingOption,
    updateReferralSharingPreference,
    resetPasswordAndRedirect
};
